import { locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  ZH_HK,
  EN_HK,
  EN_AU,
  EN_CA,
  EN_GB,
  EN_NZ,
  ES_MX,
  FR_CA,
  JA_JP,
  EN_SG,
} = locales;

export const hasTealeafRule = [
  EN_AU,
  EN_CA,
  EN_NZ,
  ES_MX,
  FR_CA,
  JA_JP,
  EN_HK,
  EN_SG,
  ZH_HK,
];

export const isStrategicInitiativeRule = {
  devFlag: 'strategicInitiative',
  devLocales: [EN_GB, EN_US],
};
